module.exports = __webpack_public_path__ + "img/ground-eleven-open.f6c86fe0.gif";